"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var root = require("window-or-global");
// create a dirty HTML snippet for success tracking and add it just before </body>
function insertSuccessHtml(url) {
    if (!root.document) {
        return;
    }
    var container = createContainerTag();
    container.appendChild(createScriptTag(url));
    root.document.body.appendChild(container);
}
exports.insertSuccessHtml = insertSuccessHtml;
// create a invisible div to hold the container
function createContainerTag() {
    if (!root.document) {
        return;
    }
    var container = root.document.createElement('div');
    container.setAttribute('style', 'display: none');
    return container;
}
// create a script tag with the predefined content, deptid == 16 for BEA
function createScriptTag(url) {
    if (!root.document) {
        return;
    }
    var script = root.document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.innerHTML = scriptContent.replace('$URL', url);
    return script;
}
var scriptContent = "\n<!--\n(function() {\n    var realpersonReportLoader = function() {\n        var e = document.createElement('script');\n        e.type = 'text/javascript'; e.async = true; e.id = 'realpersonReportLoader';\n        e.src = '$URL';\n        document.getElementsByTagName('head')[0].appendChild(e);\n    };\n    realpersonReportLoader();\n})();\n//-->\n";
//# sourceMappingURL=insert_success_html.js.map